import React, { useState } from 'react'
import { Modal, message} from 'antd'
import {LeadBusinessSearch, LeadBusinessResult} from '../../index'
import * as API from '../../../api'
import './index.less'
const businessKey = {
	'酒店商品库': 'jd',
	'景区商品库': 'jq',
	'民宿商品库': 'ms',
	'知识产权数据库': 'zs'
}
const dataTypeName = {
	'image_list': '图片',
	'video_list': '视频',
	'text_list': '文字',
}
const LeadBusiness = (props) => {
	const { visible } = props
	const [businessParams, setBusinessParams] = useState({businessIdList: [1,2,6,5], sug: ''})
	const [confirmLoading, setConfirmLoading] = useState(false)
	const [submitValue, setSubmitValue] = useState([])
	const getBusinessSearch = (params) => {
		setBusinessParams(params)
		// popupBusinessParams = params
	}
	const getSubmitValue = (value) => {
		setSubmitValue(value)
	}

	const handleSubmitValue = () => {
		const result = []
		const businesskeys = Object.values(businessKey)
		const typeKeys = Object.keys(dataTypeName)
		businesskeys.forEach(business => {
			if(submitValue[business]) {
				typeKeys.forEach(type => {
					const dataList = submitValue[business][type]
					if(submitValue[business][type] && dataList) {
						dataList.forEach(item => {
							if(item.data) {
								item.data.forEach(url => {
									result.push({
										st_fileurl: url.slice(0,url.lastIndexOf('?')),
										type: dataTypeName[type]
									})
								})
							}
						})
					}
				})
			}
		})
		return result
	}
	const handleSubmit = async () => {
		setConfirmLoading(true)
		try {
			const submitValue = handleSubmitValue()
			const replaceUrl = async (item: { st_fileurl: any; type: string }, i: number) => {
				const { st_fileurl: url } = item
				const params = { fileurl: url }
				if(
					!url.endsWith('.JPG') &&
					!url.endsWith('.PNG') &&
					!url.endsWith('.jpg') &&
					!url.endsWith('.png')
				) {
					if(item.type === '图片') params.st_format = 'jpg'
				}
				const { code, data } = await API.addFileForUrl(params)
				if (code === 0) {
					submitValue[i].st_fileurl = data
				} else {
					message.error('图片转换出错')
				}
			}
			const promises = submitValue.map((item, i) => replaceUrl(item, i))
			await Promise.all(promises)
			props.handleLeadBusinessData(submitValue)
			setConfirmLoading(false)
		} catch (error) {
			setConfirmLoading(false)
		}
		props.handleLeadBusiness(false)
	}
	const handleCancel = () => {
		props.handleLeadBusiness(false)
	}
	return (
		<Modal
			wrapClassName="business-modal"
			forceRender
			visible={visible}
			title="业务数据"
			onOk={handleSubmit}
			onCancel={handleCancel}
			confirmLoading={confirmLoading}
			centered
		>
			<LeadBusinessSearch businessIdList={businessParams.businessIdList} getSearch={getBusinessSearch}/>
			<LeadBusinessResult
				businessParams={businessParams}
				showQuickEnter={false}
				submit={getSubmitValue}
			/>
		</Modal>
	)
}
LeadBusiness.defaultProps = {
	visible: false,
	businessParams: {
		businessIdList: [1,2,6,5],
		sug: ''
	}
}
export default LeadBusiness